import { GroupedSelectOption, SelectOption } from '../../../../types/SelectInput'
import { StylesConfig } from 'react-select'
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters'

export const getSelectInputClassNames = ({
    isMulti = false,
    isInline = false,
    isSearchable = false,
    readOnly = false,
    showAsTag = false,
}: {
    isMulti: boolean
    isInline: boolean
    isSearchable: boolean
    readOnly: boolean
    showAsTag: boolean
}): string => {
    let classes = ['select-input']
    classes.push(isMulti ? 'select-input--multi' : 'select-input--single')
    classes.push(isInline ? 'select-input--inline' : 'select-input--block')
    classes.push(isSearchable ? 'select-input--searchable' : 'select-input--not-searchable')
    if (readOnly) classes.push('select-input--readonly')
    if (showAsTag && !isMulti) classes.push('select-input--show-as-tag')

    return classes.join(' ')
}

export const getSelectContainerClassNames = (isInline: boolean, classes: string, className: string) => {
    let classList = ['border items-center']
    classList.push(isInline ? 'inline-flex' : 'flex')
    if (classes) classList.push(classes)
    if (className) classList.push(className)

    return classList.join(' ')
}

export const getCustomSelectInputStyles = (
    showMultiLine: boolean,
    isSearchable: boolean,
): StylesConfig<SelectOption, boolean, GroupedSelectOption> => {
    return {
        valueContainer: (provided, _) => ({
            ...provided,
            ...(showMultiLine && { display: 'flex', flexWrap: 'nowrap' }),
            cursor: 'pointer',
        }),
        placeholder: (provided, state) => ({
            ...provided,
            ...(state.isFocused && isSearchable && { display: 'none' }),
        }),
        menu: (provided) => ({
            ...provided,
            marginTop: '4px',
            marginBottom: '4px',
            zIndex: '100',
            borderRadius: 0,
        }),
    }
}

export const getFilterOption = (
    option: FilterOptionOption<SelectOption>,
    input: string,
    showMultiLine: boolean = false,
): boolean => {
    if (showMultiLine) {
        return input ? `${option.label} ${option.data.footer}`.toLowerCase().includes(input.toLowerCase()) : true
    }

    return input ? option.label?.toLowerCase().includes(input.toLowerCase()) : true
}
